module.exports = __webpack_public_path__ + "img/cockfight-menu-active-icon.ba108c07.svg";